<template>
    <section class="select-gearbox">
        <div class="configurator__container container">
            <StepBar step-name="Select your gearbox" :step="1" :steps="7"/>

            <div class="configurator__flex-container">
                <div class="configurator__flex-left">
                    <Navigation
                        :go-to-step="{ name: 'select-model', params: { brand: brand }, query: { id: configuratorId } }"/>

                    <ImageGallery/>
                </div>

                <div class="configurator__flex-right">
                    <Card :title="model.model_title" description="Choose your gearbox:" :price="cheapestPrice">
                        <RadioButton v-model="selectedGearbox" id-key="id" value-key="value" price-key="price" :options="gearboxes" :show-prices="true" />
                    </Card>

                    <div ref="continueButton" class="configurator__continue-btn-container">
                        <button class="btn btn--primary btn--min-width btn--full-width-xs" :class="{'btn--disabled': !gearboxChoice}" :disbled="!gearboxChoice" @click="nextStep">Continue</button>
                    </div>

                    <SaveConfiguration/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import EventObject from "../../modules/tracking/EventObject";
import {mapState} from "vuex";
import scrollToElement from "../modules/scrollToElement";

export default {
    props: {
        brand: {
            type: String,
            required: true
        },
        urlModel: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            loading: true,
        }
    },
    methods: {
        nextStep: function() {
            if (!this.gearboxChoice) {
                return;
            }

            new EventObject("New Car - Configurator", "Next Step", "Clicked to Step 2 of 7: Select fuel").dispatch();

            this.$router.push({
                name: 'select-fuel',
                params: {brand: this.brand, urlModel: this.urlModel},
                query: {id: this.configuratorId}
            });
        }
    },
    created() {
        document.title = `${this.model.model_title} Configurator | Configure My New ${this.manufacturer} Car`;

        this.$store.commit('setSelectedVehiclePrice', this.cheapestPrice);

        if (this.gearboxes.length == 1) {
            this.selectedGearbox = this.gearboxes[0].id;
        }

        if (localStorage.getItem(`configurator-${this.brand}`)) {
            localStorage.removeItem(`configurator-${this.brand}`);
        }

        localStorage.setItem(`configurator-${this.brand}`, JSON.stringify({
            "configuratorId": this.configuratorId,
            "model": this.model.model_title
        }))
    },
    computed: {
        ...mapState(['model', 'availableGearboxes', 'gearboxChoice', 'configuratorId', 'manufacturer', 'selectedVehiclePrice']),
        gearboxes() {
            return this.availableGearboxes.map(gearbox => {
                let value = gearbox.transmission.charAt(0).toUpperCase() + gearbox.transmission.toLowerCase().slice(1);
                return {
                    id: gearbox.transmission,
                    value: value.replace('Auto', 'Automatic'),
                    price: gearbox.pricing_display_price - this.cheapestPrice
                }
            });
        },

        selectedGearbox: {
            get: function () {
                return this.$store.state.gearboxChoice;
            },
            set: function (selectedGearboxId) {
                for (let index = 0; index < this.gearboxes.length; index++) {
                    const gearbox = this.gearboxes[index];

                    if (gearbox.id != selectedGearboxId) {
                        continue;
                    }

                    this.$store.commit('setGearBoxChoice', gearbox.id);
                    this.$store.commit('setSelectedVehiclePrice', gearbox.price + this.cheapestPrice);
                    scrollToElement(this.$refs['continueButton']);
                    return;
                }
            },
        },

        cheapestPrice() {
            return Math.min(...this.availableGearboxes.map((availableGearbox) => availableGearbox.pricing_display_price))
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/configurator/pages/SelectGearbox.vue